import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/pages.css";
import { updateLift, getLiftById } from "../firebase/firestore";

const Lift = () => {
  const { liftId } = useParams();
  const navigate = useNavigate();
  const [lift, setLift] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editFormData, setEditFormData] = useState({
    date: "",
    muscleGroup: "",
    completed: false,
    notes: "",
  });

  const handleToggleCompletion = async (index, isCompleted) => {
    try {
      const updatedMovements = [...lift.movements];
      updatedMovements[index] = { ...updatedMovements[index], completed: isCompleted };
  
      // Update Firestore
      await updateLift(lift.id, { movements: updatedMovements });
  
      // Update Local State
      setLift({ ...lift, movements: updatedMovements });
    } catch (error) {
      console.error("Error updating movement completion:", error);
    }
  };
  
  const handleToggleLiftCompletionDirect = async (isCompleted) => {
    try {
      // Update Firestore
      await updateLift(lift.id, { completed: isCompleted });
  
      // Update Local State
      setLift({ ...lift, completed: isCompleted });
    } catch (error) {
      console.error("Error updating lift completion:", error);
    }
  };
  

  // Fetch the lift data dynamically
  useEffect(() => {
    const fetchLift = async () => {
      try {
        const liftData = await getLiftById(liftId);
        if (liftData) {
          setLift(liftData);
          setEditFormData({
            date: liftData.date,
            muscleGroup: liftData.muscleGroup,
            completed: liftData.completed,
            notes: liftData.notes,
          });
        }
      } catch (error) {
        console.error("Error fetching lift:", error);
      }
    };

    fetchLift();
  }, [liftId]);

  const handleEditChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditFormData({
      ...editFormData,
      [name]: type === "checkbox" ? checked : value,
    });
  };


  const handleSaveChanges = async () => {
    try {
      if (!lift) return;
      await updateLift(lift.id, editFormData); // Update the lift in Firestore
      setLift({ ...lift, ...editFormData }); // Update local state
      setIsEditing(false); // Exit editing mode
    } catch (error) {
      console.error("Error updating lift:", error);
    }
  };

  const handleEditMovement = (index) => {
    navigate(`/lift/${liftId}/movement`, { state: { movementIndex: index, movementData: lift.movements[index] } });
  };  


  if (!lift) {
    return (
      <div>
        <h1>Lift not found</h1>
        <button onClick={() => navigate("/")}>Back to Log</button>
      </div>
    );
  }

  return (
    <div className="lift-page-container">
      <h1 className="page-title">Lift</h1>
  
      {isEditing ? (
        <form>
          <label>
            Date:
            <input
              type="date"
              name="date"
              value={editFormData.date}
              onChange={handleEditChange}
            />
          </label>
          <label>
            Muscle Group:
            <select
              name="muscleGroup"
              value={editFormData.muscleGroup}
              onChange={handleEditChange}
            >
              <option value="Push">Push</option>
              <option value="Pull">Pull</option>
              <option value="Core">Core</option>
              <option value="Legs">Legs</option>
              <option value="Full Body">Full Body</option>
            </select>
          </label>
          <label>
            Completed:
            <input
              type="checkbox"
              name="completed"
              checked={editFormData.completed}
              onChange={handleEditChange}
            />
          </label>
          <label>
            Notes:
            <textarea
              name="notes"
              value={editFormData.notes}
              onChange={handleEditChange}
            />
          </label>
          <button type="button" onClick={handleSaveChanges}>
            Save
          </button>
          <button type="button" onClick={() => setIsEditing(false)}>
            Cancel
          </button>
        </form>
      ) : (
        
        <div>
          <div>
            <input
              type="checkbox"
              checked={lift.completed} // Reflect the current state
              onChange={(e) => handleToggleLiftCompletionDirect(e.target.checked)} // Handle toggle directly
              style={{ marginLeft: "8px" }}
            />
          </div>
          <button onClick={() => navigate("/")}>Back to Log</button>
          <button onClick={() => setIsEditing(true)}>Edit Lift</button>
          <button onClick={() => navigate(`/lift/${lift.id}/movement`)}>
            Add Movement
          </button>
          <p>
            <strong>Date:</strong> {lift.date}
          </p>
          <p>
            <strong>Muscle Group:</strong> {lift.muscleGroup}
          </p>
          <p>
            <strong>Notes:</strong> {lift.notes || "None"}
          </p>
        </div>
      )}
      
      <h2>Movements</h2>
        {lift.movements && lift.movements.length > 0 ? (
          <ul className="movements-list">
            {lift.movements.map((movement, index) => (
              <li
                key={index}
                className="movement-item"
              >
                {/* Completed Checkbox */}
                <input
                  type="checkbox"
                  className="lift-page-checkbox"
                  checked={movement.completed} // Display completed status
                  onChange={(e) => {
                    e.stopPropagation(); // Prevent navigation when clicking checkbox
                    handleToggleCompletion(index, e.target.checked); // Handle completion toggle
                  }}
                />
                {/* Movement Details */}
                <div
                  onClick={() => handleEditMovement(index)} // Navigate to edit on click of the movement details
                  className="movement-details"
                >
                  <strong>{movement.name}</strong> - {movement.sets} sets x {movement.reps} reps @{" "}
                  {movement.weight} lbs
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p>No movements added yet.</p>
      )}

    </div>
  );
  
};

export default Lift;
